import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function ModalBody({ children }) {
  return (
    <div>
      {children}
    </div>
  );
}

ModalBody.propTypes = propTypes;
